import { FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Carte, COL, Indisponible, Vide, dateFr, isErreur } from "./shared";

const TYPES = { analyse_sol_pdf: "Analyse de sol", dossier_parcelle: "Dossier parcelle" };
const taille = (o) => (o == null ? "" : o < 1024 * 1024 ? `${Math.max(1, Math.round(o / 1024))} Ko`
  : `${(o / 1024 / 1024).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} Mo`);

export default function DocumentsCard({ data, parcelId }) {
  const navigate = useNavigate();
  return (
    <Carte titre="Documents" numero="9" icon={FileText} testId="fiche-documents"
      action={<button type="button" className="min-h-[44px] text-sm font-semibold" style={{ color: COL.green }}
        onClick={() => navigate(`/carnet/${encodeURIComponent(parcelId)}?tab=documents`)}>Gérer</button>}>
      {isErreur(data) ? <Indisponible /> : data.length ? (
        <ul className="divide-y" style={{ borderColor: COL.line }}>
          {data.map((d) => (
            <li key={d.document_id} className="py-2">
              <div className="text-sm font-medium break-all">{d.nom}</div>
              <div className="text-xs text-gray-500">{[TYPES[d.type] || d.type, dateFr(d.date), taille(d.taille_octets)].filter(Boolean).join(" · ")}</div>
            </li>
          ))}
        </ul>
      ) : <Vide>Aucun document.</Vide>}
    </Carte>
  );
}
